// Saisie éclair — favoris dérivés de l'historique de consommation.
import { median, round } from './statistics';

export interface FoodUsage {
  foodId: string;
  foodName: string;
  grams: number;
}

export interface FrequentFood {
  foodId: string;
  foodName: string;
  count: number;
  /** Grammage médian (robuste aux portions aberrantes). */
  medianGrams: number;
}

// Les `limit` aliments les plus fréquents (fréquence puis nom). Entrées sans foodId ignorées.
export function frequentFoods(usages: readonly FoodUsage[], limit = 6): FrequentFood[] {
  const byFood = new Map<string, { name: string; grams: number[] }>();
  for (const u of usages) {
    if (!u.foodId) continue;
    const entry = byFood.get(u.foodId);
    if (entry) entry.grams.push(u.grams);
    else byFood.set(u.foodId, { name: u.foodName, grams: [u.grams] });
  }

  return [...byFood.entries()]
    .map(([foodId, { name, grams }]) => ({
      foodId,
      foodName: name,
      count: grams.length,
      medianGrams: round(median(grams)),
    }))
    .sort((a, b) => b.count - a.count || a.foodName.localeCompare(b.foodName))
    .slice(0, limit);
}
